// CSAT feedback (story #1395) — feature constants.
// Kept self-contained so the feature stays decoupled from the rest of the app.

export const CSAT_PLATFORM = 'web'

// Sentinel used when the form is opened outside any known tool route. It is a real string
// on purpose: it separates "opened with no tool" from "tool property failed to attach".
export const CSAT_TOOL_GENERAL = 'general'

// Entry point that triggered the form. 'in_tool_button' is reserved for a future in-tool trigger.
export const CSAT_SOURCE_PASSIVE_LINK = 'passive_link'

// Per-user "already responded" record lives under this localStorage key.
export const CSAT_RESPONSES_STORAGE_KEY = 'csat_feedback_responses'

// Known tool routes, matched against the current pathname to attribute feedback by tool.
export const CSAT_TOOL_ROUTES = [
  { segment: 'dashboard', tool: 'dashboard' },
  { segment: 'bilabs', tool: 'bilabs' },
  { segment: 'accounts', tool: 'accounts' },
  { segment: 'crop-master', tool: 'crop-master' },
  { segment: 'layers', tool: 'layers' }
]
